import React from "react";
import "./footer.css";
import gpt3Logo from "../../assets/logo.svg";

const Footer = () => {
  return (
    <div className="gpt3__footer section__padding">
      <div className="gpt3__footer-heading">
        <h1 className="gradient__text">
        Do you want to step in to the future before others
        </h1>
      </div>

      <div className="gpt3__footer-btn">
        <p>Request Early Access</p>
      </div>

      <div className="gpt3__footer-links">
        <div className="gpt3__footer-links_logo">
          <img src={gpt3Logo} alt="logo" />
          <p>13 Artificial Str, Abuja Nigeria.</p>
        </div>
        <div className="gpt3__footer-links_div">
          <h4>Links</h4>
          <p>Sponsors</p>
          <p>Social Media</p>
          <p>Patners</p>
          <p>Contact</p>
        </div>
        <div className="gpt3__footer-links_div">
          <h4>Company</h4>
          <p>Term & Condition</p>
          <p>Privacy Policy</p>
          <p>Contact</p>
        </div>
        <div className="gpt3__footer-links_div">
          <h4>Get in Touch</h4>
          <p>13 Artificial Str, Abuja Nigeria.</p>
          <p>+234 90201 51627</p>
          <p>ai@intelligence.net</p>
        </div>
      </div>

      <div className="gpt3__footer-copyright">
        <p>@ 2023. All rights reserved.</p>
        <p>Designed by Salau Umar</p>
      </div>
    </div>
  );
};

export default Footer;
